class PushNotifications {

    constructor (publicVapidKey) {
        this.publicVapidKey = publicVapidKey
        this.serviceWorkerRegistation = null
    }

    notificationEnable () {
        Notification.requestPermission().then(
            result => {
                if (result === 'granted') { // User granted permission
                    this.createSubscription().then(
                        sub => {
                            // subscription created on client
                            this.saveSubscription(sub)
                        }
                    )
                }
        })
    }

    createSubscription () {
        // ask for active service worker registration
        if(this.serviceWorkerRegistation === null) {
            // no active service worker registration
            return navigator.serviceWorker.ready.then(
                swreg => {
                    // new service worker registration
                    this.serviceWorkerRegistation = swreg
                    return this.subscribe(this.serviceWorkerRegistation)
                }
            )
        }
        else {
            // active service worker registration
            return this.subscribe(this.serviceWorkerRegistation)
        }
    }

    getSubscription (swreg) {
        // ask for available subscription
        return swreg.pushManager.getSubscription()
    }

    subscribe (swreg) {
        // create new subscription for this browser on this device
        const vapidKeyPublic = this.publicVapidKey
        const convertedPublicVapidKey = this.urlBase64ToUint8Array(vapidKeyPublic)
        return swreg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: convertedPublicVapidKey
        })
    }

    findSubscription () {
        // get active service worker registration
        return navigator.serviceWorker.ready.then(
            swreg => {
                // got active subscription
                this.serviceWorkerRegistation = swreg
                return this.getSubscription(this.serviceWorkerRegistation)
            }
        )
    }

    urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4)
        const base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/')
        const rawData = window.atob(base64)
        let outputArray = new Uint8Array(rawData.length)
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i)
        }
        return outputArray
    }

    askNotificationEnable() {
        if ('Notification' in window && 'serviceWorker' in navigator) {
            this.notificationEnable()
        }
    }

    findActiveSubscription() {
        this.findSubscription().then(
            sub => {
                if (sub !== null) { // active subscription found
                    this.saveSubscription(sub)
                } else {
                    this.askNotificationEnable()
                }
            }
        )
    }

    saveSubscription (sub) {
        this.subscription = sub
        localStorage.setItem('subscription', JSON.stringify(this.subscription))
        return axios.post(`/subscription`, {
            subscription: this.subscription 
        })
    }
}

export default PushNotifications